import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { IAssortmentGroup } from '../models/data/IAssortmentGroup'

export interface IBlankAssortmentGroupParams {
  fYear: number
  partnerId: string
  programType: ProgramTypes
  category: string
}

export const createBlankAssortmentGroup = ({
  fYear,
  partnerId,
  programType,
  category,
}: IBlankAssortmentGroupParams): IAssortmentGroup => {
  return {
    EntryId: -1,
    BusinessPercentage: 0,
    FYear: fYear,
    PartnerId: partnerId,
    ProgramType: programType,
    Category: category,
    GroupName: '',
    SortOrder: 1,
    UnitsCount: 0,
    isChanged: true,
  }
}
